import React from 'react';

const CareersContent: React.FC = () => {
  const handleContactClick = () => {
    window.REACT_APP_NAVIGATE('/contact');
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="prose prose-lg max-w-none">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-900 mb-8">
              诚聘优秀生物信息学人才
            </h2>
            <div className="text-lg text-gray-700 leading-relaxed space-y-8">
              <p>
                我们正在寻找优秀的生物信息学人才加入我们的专业团队,共同推动生命科学研究的前沿发展。
                无论您是在职还是寻求兼职机会,我们都为您提供灵活的合作模式。
              </p>
              
              <div className="text-left">
                <h3 className="text-xl font-bold text-gray-900 mb-4">项目研究方向</h3>
                <p className="mb-4">转录组分析:单细胞转录组分析、空间转录组分析、bulk RNA-seq分析</p>
                <p className="mb-4">表观组学分析:scATAC-seq分析、ChIP-seq分析、DNA甲基化分析</p>
                <p className="mb-4">微生物与代谢组:16S菌群测序分析、代谢组学分析、空间代谢组学</p>
                <p className="mb-4">多组学联合分析:机器学习和AI分析、系统生物学建模、调控网络构建</p>
              </div>

              <div className="text-left">
                <h3 className="text-xl font-bold text-gray-900 mb-4">岗位要求</h3>
                <p className="mb-3">学历要求:博士学历,生物信息学或相关专业</p>
                <p className="mb-3">熟练掌握 R / Python,能独立完成组学数据分析任务</p>
                <p className="mb-3">至少熟悉一类数据的标准分析流程(如 Seurat、Scanpy等)</p>
                <p className="mb-3">理解常用分析方法的基本原理,具备扎实的统计学基础</p>
                <p className="mb-3">有SCI期刊发表经验(第一作者),了解高水平期刊审稿标准</p>
                <p className="mb-3">工作认真负责,沟通顺畅,能够按时高质量交付项目成果</p>
              </div>

              <div className="text-left">
                <h3 className="text-xl font-bold text-gray-900 mb-4">我们提供</h3>
                <p className="mb-3">提供远程工作支持、具有竞争力的报酬以及灵活的工作时间安排</p>
              </div>

              <p className="text-center text-lg">
                如果您符合以上要求,并希望在生物信息学领域发挥专长,我们诚挚邀请您加入我们的团队。
                让我们一起推动生命科学研究的创新发展,为科学进步贡献力量。
              </p>
            </div>
          </div>

          <div className="text-center">
            <button
              onClick={handleContactClick}
              className="bg-blue-600 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer inline-flex items-center"
            >
              <i className="ri-mail-line mr-2"></i>
              立即联系我们
            </button>
            <p className="text-gray-600 mt-4">
              点击上方按钮,通过联系页面与我们取得联系
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CareersContent;
